import {
  DISPLAY_GO_HOME
} from './constants';

export const displayGoHome = show => ({
  type: DISPLAY_GO_HOME,
  payload: show
});
 


// WEBPACK FOOTER //
// ./src/features/registration/accountCreated/actionTypes.js